// Layout.jsx — now delegates everything to CheckoutLayout
import React from "react";
import CheckoutLayout from "./components/checkout/CheckoutLayout.jsx";

const Layout = ({
  fetchCart,
  cartData,
  setCartData,
  setPaymentStatus,
  setAppLoader,
  setHeaderTitle,
}) => {
  return (
    <CheckoutLayout
      fetchCart={fetchCart}
      cartData={cartData}
      setPaymentStatus={setPaymentStatus}
      setAppLoader={setAppLoader}
      setHeaderTitle={setHeaderTitle}
    />
  );
};

export default Layout;